import theme from 'theme';

export const buttonSpanSx = {
  marginTop: '2px'
};

export const limitedSpanSx = {
  color: theme.palette.text.primary,
  display: 'inline-block',
  maxWidth: theme.width.limitedSpan,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};
